import { Icon } from "icons";

export function DataTableLoading() {
  return (
    <div className="flex items-center justify-center py-12">
      <Icon
        name="tabler-loader-2"
        className="size-6 animate-spin text-muted-foreground"
      />
    </div>
  );
}
